<template>
  <div class="page-header">
    <div v-if="headerArch" class="page-header-background">
      <CustomIcon name="header-arch-short" />
    </div>
    <div class="page-header-inner">
      <div
        v-if="goBack"
        @click="handleOnClickEvent"
        class="page-header-nav-back"
      >
        <CustomIcon name="arrow" />
      </div>
      <div class="page-header-title">
        <CustomIcon v-if="icon" :name="icon" />
        <h5 v-else-if="title" class="page-header-title-text">{{ title }}</h5>
      </div>
    </div>
  </div>
</template>

<script>
import CustomIcon from "./CustomIcon.vue";
export default {
  name: "page-header",
  props: {
    goBack: Function,
    icon: String,
    title: String,
    headerArch: Boolean,
  },
  components: { CustomIcon },
  computed: {
    handleOnClickEvent() {
      if (this.goBack) {
        return this.goBack;
      }

      return () => null;
    },
  },
};
</script>
